import { FC } from 'react'
import React from 'react'
import Image from 'next/image'
import { PriceRange } from '@segway/core'
import { GetCategoryProductsQuery } from '@segway/core/src/graphql/generated/graphql'

import { Link } from '@/i18n/navigation'

type TProducts = NonNullable<GetCategoryProductsQuery['products']>
type TProductItems = NonNullable<TProducts['items']>
type TProductItem = NonNullable<TProductItems[number]>

interface ProductItemProps extends React.HTMLAttributes<HTMLDivElement> {
  product: TProductItem
}

const SearchedProductItem: FC<ProductItemProps> = ({ product }) => {
  const { name, image, price_range, url_key, sw_simple_description } = product

  return (
    <div className="product-container xl:pb-[24px relative rounded-[20px] pb-[36px] xl:border-solid xl:bg-[#F3F3F4]">
      <div className="rounded-t-[20px m-auto flex items-center justify-center overflow-hidden xl:bg-[#F3F3F4]">
        <Link className="flex aspect-square items-center" href={`/${url_key}` || ''}>
          <Image
            src={image?.url || ''}
            alt={name || ''}
            width={348}
            height={348}
            style={{ objectFit: 'contain' }}
            className="aspect-square duration-300 hover:lg:scale-110"
          />
        </Link>
      </div>
      <div className="px-[20px]">
        <div className="w-full overflow-hidden text-ellipsis whitespace-nowrap px-0 font-miSansMedium380 text-[10px] text-[#6E6E73] xl:h-[17px] xl:text-base">
          {sw_simple_description}
        </div>
        <div className="mt-[6px] line-clamp-2 overflow-hidden text-ellipsis px-0 font-miSansMedium380 text-base text-black xl:mt-2 xl:line-clamp-1 xl:text-2xl">
          <Link href={`/${url_key}` || ''}>{name}</Link>
        </div>
        <div className="mt-3 px-0">
          <PriceRange
            priceProps={{
              containerStyle: 'text-base',
              currencyStyle: 'text-[12px] mr-[2px]',
              textStyle: 'text-[14px] xl:text-[16px]',
            }}
            originalPriceProps={{
              containerStyle: 'text-base',
              currencyStyle: 'text-[12px] mr-[2px]',
              textStyle: 'text-[14px] xl:text-[16px]',
            }}
            priceRange={price_range}
          />
        </div>
      </div>
    </div>
  )
}

export default SearchedProductItem
